// extracted by mini-css-extract-plugin
export default {"sectionTitle":"HomePage_sectionTitle__agH-y"};